import React from 'react';
import { useTranslation } from "react-i18next";

const ContactAddress = () => {
  const { t } = useTranslation(); 
  const address = "Unii Lubelskiej 3, 61-249 Poznań, Poland";
  const email = "biuro@goatskarate.pl";
  const phone = "+48 505 875 735";
  const phoneLink = "tel:+48505875735"; // remove spaces for tel link
  const mailLink = `mailto:${email}`;

  return (
    <div className="contact-section">
      <h2 className="contact-title">📞 {t("contact.contactUs.title")}</h2>
      <p><strong>{t("contact.contactUs.address")}:</strong> {address}</p>
      <p>
        <strong>{t("contact.contactUs.email")}:</strong>{' '}
        <a href={mailLink}>{email}</a>
      </p>
      <p>
        <strong>{t("contact.contactUs.phone")}:</strong>{' '}
        <a href={phoneLink}>{phone}</a>
      </p>
    </div>
  );
};

export default ContactAddress;
